import { EarlyCareerReportState } from '../interface/EarlyCareerReportInterface'

export default function (
    state: EarlyCareerReportState = {
        EarlyCareerReportFilterSavedValues : {
            ecr_award: [],
            gender: [],
            suborg: [],
            funder: [],
            no_compare: true,
            ecr_award_compare: false,
            gender_compare: false
        }
    },
    action
) {
    let propertyName: string;

    switch (action.type) {
        case "EARLYCAREER_REPORT_LOADING":
            //console.log(action.payload);
            var newState = Object.assign({}, state);
            propertyName = "EarlyCareerReportFilterSelection";
            newState[propertyName] = action.payload[propertyName];

            propertyName = "EarlyCareerReportFilterSavedValues";
            newState[propertyName] = action.payload[propertyName];
            //console.log(newState);
            //return action.payload;
            return newState;
        case "APPLY_CLICKED":
            propertyName = "ApplyClicked";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "BASIC_INFO":
            propertyName = "EarlyCareerReportBasicInfo";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "ECR_RELEASE":
            propertyName = "ecrRelease";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "FILTER_COUNTS":
            propertyName = "EarlyCareerReportFilterCounts";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "FILTER_CLEAR":
            propertyName = "EarlyCareerReportFilterSelection";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "FILTER_SELECTION":
            propertyName = "EarlyCareerReportFilterSelection";
            var newState = Object.assign({}, state);
            newState[propertyName][action.payload["key"]] = action.payload["value"];
            return newState;
        case "FILTER_SAVED_VALUES":
            propertyName = "EarlyCareerReportFilterSavedValues";
            var newState = Object.assign({}, state);
            newState[propertyName][action.payload["key"]] = action.payload["value"];
            return newState;
        case "SUBORGS_DEFINED":
            propertyName = "SuborgsDefined";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SUBORGS":
            propertyName = "Suborgs";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "AWARD_COUNT":
            propertyName = "EarlyCareerReportAwardCount";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "AWARD_COUNT_2":
            propertyName = "EarlyCareerReportAwardCount_2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "JOURNAL_RANK":
            propertyName = "JournalRankData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "JOURNAL_RANK_2":
            propertyName = "JournalRankData_2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "AUTHOR":
            propertyName = "AuthorData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "AUTHOR_2":
            propertyName = "AuthorData_2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "PUB":
            propertyName = "PubData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "PUB_2":
            propertyName = "PubData_2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SANKEY":
            propertyName = "SankeyData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "POE":
            propertyName = "POEData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GRANT":
            propertyName = "GrantData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "TEAM":
            propertyName = "TeamData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "POE_2":
            propertyName = "POEData_2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GRANT_2":
            propertyName = "GrantData_2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "TEAM_2":
            propertyName = "TeamData_2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EARLYCAREER_METHODOLOGY":
            propertyName = "EarlyCareerMethodology";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "DOWNLOAD":
            return state;
        default:
            return state;
    }
}